/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 * @enum {string}
 */
export enum CheckoutRateSelector {
  FastestByMinDays = "FASTEST_BY_MIN_DAYS",
  FastestByAverageDays = "FASTEST_BY_AVERAGE_DAYS",
  Middle = "MIDDLE",
  MostExpensive = "MOST_EXPENSIVE",
}

export function instanceOfCheckoutRateSelector(value: any): boolean {
  for (const key in CheckoutRateSelector) {
    if (Object.prototype.hasOwnProperty.call(CheckoutRateSelector, key)) {
      if (
        CheckoutRateSelector[key as keyof typeof CheckoutRateSelector] === value
      ) {
        return true;
      }
    }
  }
  return false;
}

export function CheckoutRateSelectorFromJSON(json: any): CheckoutRateSelector {
  return CheckoutRateSelectorFromJSONTyped(json, false);
}

export function CheckoutRateSelectorFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): CheckoutRateSelector {
  return json as CheckoutRateSelector;
}

export function CheckoutRateSelectorToJSON(
  value?: CheckoutRateSelector | null,
): any {
  return value as any;
}

export function CheckoutRateSelectorToJSONTyped(
  value: any,
  ignoreDiscriminator: boolean,
): CheckoutRateSelector {
  return value as CheckoutRateSelector;
}
